/**
 * @generated SignedSource<<1f7a9d88c5e2d2706ab0e1327f89f92a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type fetchTtsLineByLineQuery$variables = {
  evenLineLang?: string | null;
  targetLang: string;
  text: string;
};
export type fetchTtsLineByLineQuery$data = {
  readonly ttsLineByLine: {
    readonly id: string;
    readonly speech: string;
  } | null;
};
export type fetchTtsLineByLineQuery = {
  response: fetchTtsLineByLineQuery$data;
  variables: fetchTtsLineByLineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "evenLineLang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetLang"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "evenLineLang",
        "variableName": "evenLineLang"
      },
      {
        "kind": "Variable",
        "name": "targetLang",
        "variableName": "targetLang"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text"
      }
    ],
    "concreteType": "TtsLineByLine",
    "kind": "LinkedField",
    "name": "ttsLineByLine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "speech",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchTtsLineByLineQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "fetchTtsLineByLineQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d9551c42a0665ad623cfe5e21dacaf4a",
    "id": null,
    "metadata": {},
    "name": "fetchTtsLineByLineQuery",
    "operationKind": "query",
    "text": "query fetchTtsLineByLineQuery(\n  $text: String!\n  $targetLang: String!\n  $evenLineLang: String\n) {\n  ttsLineByLine(text: $text, targetLang: $targetLang, evenLineLang: $evenLineLang) {\n    id\n    speech\n  }\n}\n"
  }
};
})();

(node as any).hash = "a55b4ccbc62b58ac3394721c56afea9e";

export default node;
